/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { ExcJpmamV1NetOrderState } from '@interxfi/types';
import { schema } from 'normalizr';

export const EXC_JPMAM_V1_NET_ORDER_STATE_ENTITY_NAME = 'exc.jpmam.v1.NetOrder';
export const excJpmamV1NetOrderStateEntity = new schema.Entity<ExcJpmamV1NetOrderState>(EXC_JPMAM_V1_NET_ORDER_STATE_ENTITY_NAME, {}, { idAttribute: 'netOrderId' });

